import { Badge, Menu, Portal } from '@chakra-ui/react';
import type { UnionWorksiteAffiliation } from '../../types/union'

export function WorksiteStatusMenu({ wo, onStatusChange }: {
  wo: UnionWorksiteAffiliation
  onStatusChange: (newStatus: 'covered' | 'local' | 'excluded') => void
}) {
  const currentStatus = wo.isExcluded ? 'excluded' : wo.isOverride ? 'local' : 'covered'
  const colorScheme = wo.isExcluded ? 'red' : wo.isOverride ? 'orange' : 'gray'
  const label = wo.isExcluded ? 'Excluded' : wo.isOverride ? 'Local' : 'Covered'

  return (
    <Menu.Root>
      <Menu.Trigger asChild><Badge
          colorPalette={colorScheme}
          fontSize="xs"
          variant={currentStatus === 'covered' ? 'outline' : 'subtle'}
          cursor="pointer"
          _hover={{ opacity: 0.7 }}
          onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          {label}
        </Badge></Menu.Trigger>
      <Portal><Menu.Positioner><Menu.Content>
            <Menu.Item
              fontSize="sm"
              onSelect={() => onStatusChange('covered')}
              disabled={currentStatus === 'covered'}
              value='item-0'>Covered</Menu.Item>
            <Menu.Item
              fontSize="sm"
              onSelect={() => onStatusChange('local')}
              disabled={currentStatus === 'local'}
              value='item-1'>Local</Menu.Item>
            <Menu.Item
              fontSize="sm"
              onSelect={() => onStatusChange('excluded')}
              disabled={currentStatus === 'excluded'}
              value='item-2'>Excluded</Menu.Item>
          </Menu.Content></Menu.Positioner></Portal>
    </Menu.Root>
  );
}
